<div class="d-flex flex-row align-items-center numTiersContainer">
    <div class="mr-1">
        <label class="control-label mx-1 text-nowrap" paflabel="NumTiers"></label>
    </div>
    <input *ngIf="supplier" type="text" class="form-control num-tiers-input"  [(ngModel)]="supplier.NumTiers" [disabled]="!canEdit || !editing">
    <button type="button" *ngIf="canEdit && !editing" class="btn btn-xs btn-primary ml-1" (click)="edit()"><i class="fas fa-edit"></i></button>
    <button type="button" *ngIf="canEdit && editing" class="btn btn-xs btn-success ml-1" (click)="save()"><i class="fas fa-save"></i></button>
    <button type="button" *ngIf="canEdit && editing" class="btn btn-xs btn-warning ml-1" (click)="cancel()"><i class="fas fa-undo"></i></button>

</div>